import { Box, CircularProgress, Typography } from '@mui/material';

const DepartureLocalityStep = ({
  busy,
  inventoryData,
  localityGroups,
  product,
  onSelect,
}) => {
  if (busy) {
    return (
      <CircularProgress
        size={28}
        sx={{ display: 'block', mx: 'auto', my: 3 }}
      />
    );
  }

  if (!localityGroups.length) {
    return (
      <Typography color="text.secondary" textAlign="center" py={2}>
        محل موجودی برای این محصول یافت نشد.
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="subtitle2" textAlign="center">
        {inventoryData?.productName}
        {inventoryData?.productPack ? ` - ${inventoryData.productPack}` : ''}
        {product?.quantity != null ? ` - x${product.quantity}` : ''}
      </Typography>

      {localityGroups.map(group => (
        <Box key={group.guid || group.display}>
          <Typography
            sx={{
              fontWeight: 600,
              mb: 1,
              textAlign: 'center',
            }}
          >
            {group.display}
          </Typography>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: 'repeat(2, 1fr)',
                sm: 'repeat(3, 1fr)',
                md: 'repeat(4, 1fr)',
                lg: 'repeat(5, 1fr)',
              },
              gap: 1,
            }}
          >
            {(group.items || []).map(item => (
              <Box
                key={item.guid}
                onClick={() => onSelect(item)}
                sx={{
                  'display': 'flex',
                  'flexDirection': 'column',
                  'gap': 1,
                  'border': '1px solid',
                  'borderColor': 'divider',
                  'borderRadius': 2,
                  'p': 1.5,
                  'cursor': 'pointer',
                  '&:hover': {
                    bgcolor: 'action.hover',
                  },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 700,
                    mb: 1,
                    textAlign: 'center',
                  }}
                >
                  {item.partAndCell}
                </Typography>

                <InfoRow label="ناحیه" value={item.areaDisplay} />

                <InfoRow label="قفسه" value={item.shelfDisplay} />

                <InfoRow
                  label="تعداد"
                  value={item.packQuantity ?? item.quantity}
                />

                <InfoRow label="تک عددی" value={item.quantity} />

                {item.holdQuantity != null ? (
                  <InfoRow label="HOLD" value={item.holdQuantity} />
                ) : null}
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

const InfoRow = ({ label, value }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>

      <Typography variant="body2">{value}</Typography>
    </Box>
  );
};

export default DepartureLocalityStep;
